import React from 'react';
import {
  IconButton as RMWCIconButton,
  type IconButtonProps,
  type IconButtonHTMLProps,
} from '@rmwc/icon-button';
import '@rmwc/icon-button/styles';
import 'material-icons/iconfont/material-icons.css';
import styles from './IconButton.module.scss';
import clsx from 'clsx';

const IconButton = React.forwardRef(
  (
    props: Partial<IconButtonProps & IconButtonHTMLProps>,
    ref: React.Ref<HTMLButtonElement>,
  ): React.JSX.Element => (
    <RMWCIconButton
      {...props}
      className={clsx(styles.iconButton, props.className)}
      ref={ref}
    />
  ),
);

export {IconButton};
